import { render } from "./real_name_list.vue?vue&type=template&id=96a733c2&scoped=true&ts=true"
import script from "./real_name_list.vue?vue&type=script&lang=ts"
export * from "./real_name_list.vue?vue&type=script&lang=ts"

import "./real_name_list.vue?vue&type=style&index=0&id=96a733c2&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96a733c2"]])

export default __exports__